import { colors } from "../../Styles";

export function Delete({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M260.52,96.63l-66.68-41.24,10.33,6.39c.75.46,1.74.23,2.2-.52l3.27-5.28c.46-.75.23-1.74-.52-2.2l-20.66-12.78c-.75-.46-1.74-.23-2.2.52l-3.27,5.28c-.46.75-.23,1.74.52,2.2L127.17,14.14c-2.61-1.61-6.07-.8-7.68,1.81l-3.44,5.56c-1.61,2.61-.8,6.07,1.81,7.68l133.36,82.49c2.61,1.61,6.07.8,7.68-1.81l3.44-5.56c1.61-2.61.8-6.07-1.81-7.68Z"/>
      <path d="M159.49,268.43h41.95c2.43,0,4.53-1.71,5.02-4.09l29.91-145.67c.65-3.18-1.78-6.16-5.02-6.16h-71.86s-71.86,0-71.86,0c-3.25,0-5.67,2.98-5.02,6.16l29.91,145.67c.49,2.38,2.59,4.09,5.02,4.09h41.95Z"/>
    </svg>
  );
}
